export enum Region {
  EU = 'eu-central-1',
  US = 'us-east-1',
}
